import { useState } from 'react';
import { supabase } from '../integrations/supabase/client';
import { logger } from '../lib/logger';
import { FeedbackType } from '../types/feedback';
import { useToast } from '../components/ui/use-toast';
import { useAuth } from './useAuth';

export function useFeedback() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();
  const { user } = useAuth();

  const submitFeedback = async (
    type: FeedbackType,
    message: string,
    includeLogs: boolean
  ) => {
    if (!user) {
        toast({
            title: "Erro",
            description: "Você precisa estar logado para enviar feedback.",
            variant: "destructive"
        });
        return;
    }

    setIsSubmitting(true);
    try {
      const logs = includeLogs ? logger.getLogs() : null;
      const context = {
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      };

      const { error } = await supabase.from('feedbacks').insert({
        user_id: user.id,
        type,
        message,
        context: context as any,
        logs: logs as any,
        status: 'new'
      });

      if (error) throw error;

      toast({
        title: "Feedback enviado!",
        description: "Obrigado pelo seu feedback.",
      });
      return true;

    } catch (error: any) {
      console.error('Error submitting feedback:', error);
      toast({
        title: "Erro",
        description: "Falha ao enviar feedback. Por favor, tente novamente.",
        variant: "destructive"
      });
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    submitFeedback,
    isSubmitting
  };
}
